import { KeyValueModel } from "model";
import { EnumCompartilhamentoDeDados } from "model/enums/enum-compartilhamento-dados";


export const CompartilhamentoDeDadosMock: KeyValueModel[] = [
    new KeyValueModel(EnumCompartilhamentoDeDados.VENDA, "Venda"),
    new KeyValueModel(EnumCompartilhamentoDeDados.CADASTRO, "Cadastro"),
    new KeyValueModel(EnumCompartilhamentoDeDados.TODOS, "Todos")
]